import { useState } from 'react';
import { services } from '../globals/app';
/**
 * useSearch is a custom hook and keeps the logic behind app search based on Fuse.js.
 * @param {*} query
 * @param {array} data
 * @param {array} keys
 * @return {array}
 * @final
*/
const useSearch = ({ query, data, keys }) => {
   let [results, setResults] = useState(data);

    const updateSearch = (value) => {
       services.movie.searchMovies(value)
       .then((movies) => setResults(movies.data.results));
    }

   return [
      results,
      updateSearch
    ];
}

export default useSearch;